import React from 'react';
import {
  Box,
  TextField,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DEFAULT_SALON_PUBLIC_THEME } from '../../../theme/salonPublicTheme';


const SalonThemeColorField = ({
  field,
  label,
  value,
  error = '',
  disabled = false,
  compact = false,
  onChange,
  onBlur,
  inputRef,
}) => {
  const { t } = useTranslation();
  const validPickerValue = /^#[0-9A-Fa-f]{6}$/.test(value)
    ? value
    : DEFAULT_SALON_PUBLIC_THEME[field];

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: compact ? '48px minmax(0, 1fr)' : '56px minmax(0, 1fr)',
        gap: 1.5,
        alignItems: 'start',
      }}
    >
      <Box
        component="input"
        type="color"
        aria-label={`${label} ${t('salon_theme.color_picker_suffix')}`}
        value={validPickerValue}
        onChange={(event) => {
          if (!disabled) onChange(event.target.value.toUpperCase());
        }}
        disabled={disabled}
        sx={{
          width: compact ? 44 : 52,
          height: compact ? 44 : 52,
          p: 0.5,
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      />
      <TextField
        fullWidth
        size="small"
        label={`${label} ${t('salon_theme.hex_suffix')}`}
        value={value}
        onChange={(event) => {
          if (!disabled) onChange(event.target.value);
        }}
        onBlur={() => {
          if (!disabled) onBlur();
        }}
        error={Boolean(error)}
        helperText={error || ' '}
        inputProps={{ maxLength: 7 }}
        inputRef={inputRef}
        disabled={disabled}
      />
    </Box>
  );
};

export default SalonThemeColorField;
